import React from 'react';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Switch } from '../ui/switch';
import { PermissionMatrix, togglePerm } from '../../pages/settings/RolesPermissions';

const MultiPick = ({ title, allLabel, options, value, onChange, testPrefix }) => {
  const all = value === null;
  const toggle = (id, on) => {
    const cur = new Set(value || []);
    if (on) cur.add(id); else cur.delete(id);
    onChange([...cur]);
  };
  return (
    <div className="space-y-2">
      <Label>{title}</Label>
      <label className="flex items-center gap-2 text-sm">
        <Checkbox checked={all} onCheckedChange={(v) => onChange(v ? null : [])} data-testid={`${testPrefix}-all`} />{allLabel}
      </label>
      {!all && (
        <div className="grid grid-cols-2 gap-1.5 max-h-40 overflow-y-auto border rounded-md p-2">
          {options.map((o) => (
            <label key={o.id} className="flex items-center gap-2 text-sm">
              <Checkbox checked={(value || []).includes(o.id)} onCheckedChange={(v) => toggle(o.id, !!v)} data-testid={`${testPrefix}-${o.id}`} />{o.name}
            </label>
          ))}
        </div>
      )}
      {!all && (value || []).length === 0 && <p className="text-xs text-red-600">Tick at least one, or choose "{allLabel}".</p>}
    </div>
  );
};

export const UserAccessFields = ({ formData, setFormData, branches, suppliers, catalog, rolePerms }) => {
  const custom = formData.permissions !== null;
  return (
    <div className="space-y-4 border-t pt-4">
      <MultiPick title="Branch access" allLabel="All branches" testPrefix="user-branch"
        options={branches.map((b) => ({ id: b.branch_id, name: b.name }))}
        value={formData.branch_ids} onChange={(v) => setFormData({ ...formData, branch_ids: v })} />
      <MultiPick title="Supplier access (stock takes & purchase orders)" allLabel="All suppliers" testPrefix="user-supplier"
        options={suppliers.map((s) => ({ id: s.supplier_id, name: s.name }))}
        value={formData.supplier_ids} onChange={(v) => setFormData({ ...formData, supplier_ids: v })} />
      <div className="space-y-2">
        <label className="flex items-center justify-between gap-2 text-sm font-medium">
          Custom permissions for this user
          <Switch checked={custom} data-testid="user-custom-perms-switch"
            onCheckedChange={(v) => setFormData({ ...formData, permissions: v ? [...(rolePerms || [])] : null })} />
        </label>
        <p className="text-xs text-muted-foreground">{custom ? 'This user ignores the role settings and only gets what is ticked below.' : 'Uses the permissions of the selected role (Settings > Roles & Permissions).'}</p>
        {custom && (
          <div className="max-h-72 overflow-y-auto border rounded-md px-3">
            <PermissionMatrix catalog={catalog} columns={[['user', 'Allowed']]} values={{ user: formData.permissions }}
              onToggle={(_, key, on) => setFormData({ ...formData, permissions: togglePerm(catalog, formData.permissions, key, on) })}
              testPrefix="user-perm" />
          </div>
        )}
      </div>
    </div>
  );
};
